import { forwardRef } from "react";
import InputAdornment from "@material-ui/core/InputAdornment";
import Input from "@material-ui/core/TextField";
import { Col } from "react-flexbox-grid";
import styled from "styled-components";

const TextField = styled(Input)`
  width: 100%;

  .MuiInputBase-input {
    padding: 26px 16px;
  }

  .MuiFilledInput-root {
    background-color: #efeef6 !important;
  }

  .MuiFilledInput-underline:before {
    display: none;
  }

  .MuiFilledInput-underline:after {
    display: none;
  }
`;

export const InputPhoneNumber = forwardRef(
  ({ defaultValue, type, placeholder, helperText, name }, ref) => {
    return (
      <Col md={12}>
        <TextField
          name={name}
          type={type}
          inputRef={ref}
          defaultValue={defaultValue}
          placeholder={placeholder}
          InputProps={{ startAdornment: <InputAdornment>+52</InputAdornment> }}
          variant="filled"
          helperText={helperText}
        />
      </Col>
    );
  }
);
